// extracted by mini-css-extract-plugin
export default {"save-filters-modal":"style_save-filters-modal__SYwCt","saveFiltersModal":"style_save-filters-modal__SYwCt"};